import React, { useEffect, useState } from "react";
import { Alert, Input, Label } from "reactstrap";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// action
import { registerUser } from "../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";

import AuthShell from "../../Components/Common/AuthShell";
import LoadingSpinner from "../../Components/Common/Spinner";
import Turnstile from "react-turnstile";
import { useBranding } from "../../Components/branding/Branding";

const Register = () => {
  const dispatch = useDispatch();
  const { isBrandingActive } = useBranding();

  const createUserDefaultValues = {
    Email: "",
    Password: "",
    Confirm_password: "",
    FirstName: "",
    LastName: "",
  };

  const sitekey = "0x4AAAAAAAhZMwfJAD7cG6kE";

  const [createNewUser, setCreateNewUser] = useState(createUserDefaultValues);
  const [FCMToken, setFCMToken] = useState(null);
  const [cfToken, setCfToken] = useState(""); // ✅ Turnstile token

  const handleCreateNewUser = () => {
    //check if Turnstile token is empty
    if (!cfToken) {
      alert("Please complete the Cloudflare check");
      return;
    }

    //check if FirstName is empty
    if (!createNewUser.FirstName) {
      toast.error("Please enter First Name");
      return;
    }
    //check if LastName is empty

    if (!createNewUser.LastName) {
      toast.error("Please enter Last Name");
      return;
    }
    //check if email  is empty/valid
    if (!createNewUser.Email) {
      toast.error("Please enter Email address");
      return;
    }
    if (
      !createNewUser.Email.match(
        //allow - and . in email address
        /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i
      )
    ) {
      toast.error("Please enter valid email address");
      return;
    }

    //check if Password and confirm passwd match / not empty
    if (!createNewUser.Password) {
      toast.error("Please enter Password");
      return;
    }
    if (!createNewUser.Confirm_password) {
      toast.error("Please enter Confirm Password");
      return;
    }
    if (createNewUser.Password !== createNewUser.Confirm_password) {
      toast.error("Password and Confirm password do not match");
      return;
    }
    dispatch(
      registerUser([
        ...createNewUser,
        {
          // FCMToken: FCMToken,
          cfToken: cfToken, // ✅ Pass the Turnstile token
        },
      ])
    );
  };

  const { error, registrationError, success, loading, userCreated } =
    useSelector((state) => ({
      registrationError: state.Account.registrationError,
      success: state.Account.success,
      error: state.Account.error,
      loading: state.Account.loading,
      userCreated: state.Account.user,
    }));

  const [userCratedSuccessMessage, setUserCratedSuccessMessage] =
    useState(null);
  useEffect(() => {
    if (!userCreated) return;
    if (userCreated?.user?.status === 200) {
      toast.success(userCreated?.user?.message);
      setUserCratedSuccessMessage(userCreated?.user?.message);
    } else {
      toast.error(userCreated?.user?.message);
      setUserCratedSuccessMessage(userCreated?.user?.message);
    }
  }, [userCreated]);

  document.title = `Create/Register New Account | ${isBrandingActive ? "CRMit - " : ""}Less Work. Do More.`;

  return (
    <AuthShell
      below={
        <p className="mb-0">
          Already have an account ? <Link to="/login">Signin</Link>
        </p>
      }
    >
      <div>
                      {userCreated?.status !== 200 && (
                        <div>
                          {loading ? (
                            <div className={"text-center"}>
                              <h5>
                                Please wait we are creating your account...
                              </h5>
                              <LoadingSpinner />
                            </div>
                          ) : (
                            <div className="p-2 mt-4">
                              <div className="text-center mt-2">
                                <h5 className="text-primary">
                                  Create New Account
                                </h5>
                                <p className="text-muted">
                                  Get your free {isBrandingActive && "CRMit "}account now
                                </p>
                              </div>
                              {userCreated?.status === 404 ? (
                                <Alert color="danger">
                                  <div>
                                    {/* {registrationError} */}
                                    {userCreated?.message ? (
                                      userCreated?.message
                                    ) : (
                                      <span>
                                        Email has been Register Before, Please
                                        Use Another Email Address...{" "}
                                      </span>
                                    )}
                                  </div>
                                </Alert>
                              ) : null}
                              <div className="mb-3">
                                <Label
                                  htmlFor="FirstName"
                                  className="form-label"
                                >
                                  First Name{" "}
                                  <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  id="FirstName"
                                  name="FirstName"
                                  className="form-control"
                                  placeholder="First Name"
                                  type="text"
                                  onChange={(e) => {
                                    setCreateNewUser({
                                      ...createNewUser,
                                      FirstName: e.target.value,
                                    });
                                  }}
                                  value={createNewUser.FirstName}
                                />
                              </div>{" "}
                              <div className="mb-3">
                                <Label
                                  htmlFor="LastName"
                                  className="form-label"
                                >
                                  Last Name{" "}
                                  <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  id="LastName"
                                  name="LastName"
                                  className="form-control"
                                  placeholder="Last Name"
                                  type="text"
                                  onChange={(e) => {
                                    setCreateNewUser({
                                      ...createNewUser,
                                      LastName: e.target.value,
                                    });
                                  }}
                                  value={createNewUser.LastName}
                                />
                              </div>
                              <div className="mb-3">
                                <Label
                                  htmlFor="useremail"
                                  className="form-label"
                                >
                                  Email <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  id="Email"
                                  name="Email"
                                  className="form-control"
                                  placeholder="Enter email address"
                                  type="email"
                                  onChange={(e) => {
                                    setCreateNewUser({
                                      ...createNewUser,
                                      Email: e.target.value,
                                    });
                                  }}
                                  value={createNewUser.Email}
                                />
                              </div>
                              <div className="mb-2">
                                <Label
                                  htmlFor="userpassword"
                                  className="form-label"
                                >
                                  Password{" "}
                                  <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  name="password"
                                  type="password"
                                  placeholder="Enter Password"
                                  onChange={(e) => {
                                    setCreateNewUser({
                                      ...createNewUser,
                                      Password: e.target.value,
                                    });
                                  }}
                                  value={createNewUser.Password}
                                />
                              </div>
                              <div className="mb-2">
                                <Label
                                  htmlFor="confirmPassword"
                                  className="form-label"
                                >
                                  Confirm Password{" "}
                                  <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  name="confirm_password"
                                  type="password"
                                  placeholder="Confirm Password"
                                  onChange={(e) => {
                                    setCreateNewUser({
                                      ...createNewUser,
                                      Confirm_password: e.target.value,
                                    });
                                  }}
                                />
                              </div>
                              <div className="mb-3">
                                <Turnstile
                                  sitekey={sitekey}
                                  onVerify={(token) => setCfToken(token)}
                                  theme={"light"}
                                  refreshExpired={"auto"}
                                  size={"flexible"}
                                />
                              </div>
                              <div className="mb-4">
                                <p className="mb-0 fs-12 text-muted fst-italic">
                                  By registering you agree to the {isBrandingActive && "CRMit"}{" "}
                                  <Link
                                    target="_blank"
                                    to="https://www.crmit.app/terms-conditions/"
                                    className="text-primary text-decoration-underline fst-normal fw-medium"
                                  >
                                    Terms of Use
                                  </Link>
                                </p>
                              </div>
                              <div className="mt-4">
                                <button
                                  className="btn btn-primary w-100"
                                  onClick={handleCreateNewUser}
                                >
                                  Sign Up
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      <div>
                        {userCreated?.status === 200 && (
                          <div
                            className={
                              "d-flex justify-content-center align-items-center flex-column"
                            }
                          >
                            <h5>Thank you Account Created</h5>

                            {userCreated?.message ? (
                              <p className={"p-2"}>{userCreated?.message}</p>
                            ) : (
                              <p className={"p-2"}>
                                Thank you your account is created please check
                                your email to activate your account. Once
                                account activated you can login to your account.
                              </p>
                            )}
                          </div>
                        )}
                      </div>
      </div>
    </AuthShell>
  );
};

export default Register;
